import { render, staticRenderFns } from "./BookNowhome.vue?vue&type=template&id=897912da&"
import script from "./BookNowhome.vue?vue&type=script&lang=js&"
export * from "./BookNowhome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports